import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=6711794c&scoped=true"
import script from "./aside.vue?vue&type=script&lang=js"
export * from "./aside.vue?vue&type=script&lang=js"
import style0 from "./aside.vue?vue&type=style&index=0&id=6711794c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6711794c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6711794c')) {
      api.createRecord('6711794c', component.options)
    } else {
      api.reload('6711794c', component.options)
    }
    module.hot.accept("./aside.vue?vue&type=template&id=6711794c&scoped=true", function () {
      api.rerender('6711794c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/component/aside.vue"
export default component.exports